import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Reporters from '../views/Reporters.vue'
import Device from '../views/Device.vue'
import Companies from '../views/Companies.vue'
import Profile from '../views/Profile.vue'
import Charts from '../views/Charts.vue'
import Logs from '../views/Logs.vue'

// import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/reporters',
    name: 'Reporters',
    component: Reporters
  },
  {
    path: '/companies',
    name: 'Companies',
    component: Companies
  },
  {
    path: '/device/:device_id',
    name: 'Device',
    component: Device
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/charts',
    name: 'Charts',
    component: Charts
  },
  {
    path: '/logs',
    name: 'Logs',
    component: Logs
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
